import { useEffect, useRef } from "react";

/**
 * A useEffect hook that does not run on mount, but only on subsequent updates,
 * useful for purely reactive effects.
 * @param effect The effect we want to trigger when triggered by dependencies.
 * @param deps List of dependencies
 */
export const useEffectAfterMount = (effect: React.EffectCallback, deps?: React.DependencyList | undefined): void => {
    const isMounted = useRef(false);

    useEffect(
        () => {
            if (isMounted.current) {
                effect();
            }

            isMounted.current = true;
        },
        // Disabled rule because we only want the useEffect to trigger when the deps list changes. Not the effect function. If we add the effect function to the dependency list, it can create an infinite loop.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        deps
    );
};
